document.addEventListener('DOMContentLoaded', () => {
	const accordions = document.querySelectorAll('.accordion-section');
	accordions.forEach((accordion, i) => {
		const header = accordion.querySelector('.accordion-section__header');
		const content = accordion.querySelector('.accordion-section__content');
		const contentInner = accordion.querySelector('.accordion-section__content-inner');
		const icon = accordion.querySelector('.accordion-section__icon');

		const { expand, collapse } =
			createAccordionControls(accordion, header, content, contentInner, icon);
		// Set initial state
		content.style.height = '0px';
		accordion.dataset.expanded = 'false';
		header.setAttribute('aria-expanded', 'false');

		if (i === 0) {
			expand();
		}

		header.addEventListener('click', () => {
			if (accordion.dataset.expanded === 'true') {
				collapse();
			} else {
				expand();
			}
		});
	});
	// resize open accordion heights
	window.addEventListener('resize', () => {
		accordions.forEach((accordion) => {
			if (accordion.dataset.expanded === 'true') {
				const content = accordion.querySelector('.accordion-section__content');
				const contentInner = accordion.querySelector('.accordion-section__content-inner');
				content.style.height = `${contentInner.offsetHeight}px`;
			}
		});
	});
});

function createAccordionControls(accordion, header, content, contentInner, icon) {
	const expand = () => {
		content.hidden = false;
		requestAnimationFrame(() => {
			accordion.dataset.expanded = 'true';
			header.setAttribute('aria-expanded', 'true');
			content.style.height = `${contentInner.offsetHeight}px`;
			icon.innerHTML = ICONS.minus;
		});
	};

	let collapseTimeout;

	const collapse = () => {
		if (collapseTimeout) {
			clearTimeout(collapseTimeout);
		}
		header.disabled = true;
		accordion.dataset.expanded = 'false';
		header.setAttribute('aria-expanded', 'false');
		content.style.height = '0px';

		collapseTimeout = setTimeout(() => {
			content.hidden = true;
			header.disabled = false;

			collapseTimeout = null;
		}, 500);

		icon.innerHTML = ICONS.plus;
	};
	return {
		expand,
		collapse,
	};
}

const ICONS = {
	plus: '<svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M8.21251 17.9227V9.78734H0.0771484V8.21275H8.21251V0.0773926H9.78709V8.21275H17.9225V9.78734H9.78709V17.9227H8.21251Z" fill="#0B332E"/></svg>',
	minus: '<svg width="18" height="2" viewBox="0 0 18 2" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M0.5 2V0H17.5V2H0.5Z" fill="#0B332E"/></svg>',
};
